<template lang="pug">
  div.user
    router-view
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'User',
  data(){
    return{
    }
  },
  methods:{
    
  },
  computed:{
  },
  mounted(){
  }
}
</script>
<style lang="scss" scoped>
</style>